import React from 'react';
import { Text, Skeleton, Flex } from '@landr/maestro';
import useDuration from 'hooks/useDuration';
import { defaultRowContainer } from './SamplesTablePlayer.styled';

export const SamplesTableTimeSkeleton = () => (
    <Flex className={defaultRowContainer}>
        <Skeleton width="xs" height="16px" />
    </Flex>
);

export const SamplesTableTime = ({
    sampleDuration,
}: {
    sampleDuration?: number;
}) => {
    const duration = useDuration(sampleDuration);

    return (
        <Flex className={defaultRowContainer}>
            <Text marginY="auto" fontSize="sm" color="text.medium">
                {duration || '0:00'}
            </Text>
        </Flex>
    );
};
